import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { ITableAction, ITableFIlterNotifier, TableColumnType } from '../../table-filter.interface'
import { TableOperatorToSentence } from '../../table-filter.constant'
import { PeriodType, PeriodTypeToLabel } from '@mg-platform/core/core-data-access'
import { formatDate } from '@angular/common'

interface IAppliedTableFilter {
  key: string
  text?: string
}

@UntilDestroy()
@Component({
  selector: 'mg-table-filters-list',
  templateUrl: './table-filters-list.component.html',
  styleUrls: ['./table-filters-list.component.scss'],
  standalone: false
})
export class TableFiltersListComponent implements OnInit {
  @Input() tableActions: ITableAction
  @Input() showExport = true
  @Input() exportLoading = false
  @Output() filterChanged = new EventEmitter<ITableFIlterNotifier>()
  @Output() exportClicked = new EventEmitter()

  filters: IAppliedTableFilter[] = []
  hasFilters = false

  ngOnInit(): void {
    if (this.tableActions.filters) {
      this.filters = Object.values(this.tableActions.filters)?.map((el) => {
        const texts = el.items?.map((item) => {
          let text: string
          switch (el.columnType) {
            case TableColumnType.date:
              if (item.value === PeriodType.Custom) {
                text = `from ${formatDate(item.extraValue.from, 'mediumDate', 'en-US')} to ${formatDate(item.extraValue.to, 'mediumDate', 'en-US')}`
              } else {
                text = `${TableOperatorToSentence[item.operator]} ${PeriodTypeToLabel[item.value]}`
              }
              break

            case TableColumnType.checkbox:
              text = `${TableOperatorToSentence[item.operator]} ${item.value?.map((x: string) => el.listItems?.find((i) => i.value === x)?.label ?? x).join(', ')}`
              break

            case TableColumnType.radio:
              text = `${TableOperatorToSentence[item.operator]} ${el.listItems?.find((i) => i.value === item.value)?.label ?? item.value}`
              break

            default:
              text = `${TableOperatorToSentence[item.operator]} ${item.value}`
              break
          }
          return text
        })

        return {
          key: el.key,
          text:
            texts && texts.length > 0
              ? `${el.label} ${texts?.join(' ' + el.aggregator + ' ')}`
              : undefined
        }
      })

      this.hasFilters = !!this.filters?.find((el) => el.text)
    }
  }

  removeItem(key: string) {
    if (!this.tableActions.filters) {
      return
    }
    const filter = this.tableActions.filters[key]

    this.filterChanged.emit({
      filter: {
        ...filter,
        items: []
      }
    })
  }

  onFilterChanged(key: string, event: ITableFIlterNotifier) {
    this.filterChanged.emit({
      ...event,
      key
    })
  }
}
